/** Hewipers for ModuleProgressStatus rendering. */

import type { ModuleProgressStatus } from '../types/cabinet';

export const STATUS_LABEL: Record<ModuleProgressStatus, string> = {
  not_started: 'не начат',
  in_progress: 'в работе',
  done: 'пройден',
  needs_rework: 'на доработке',
};

/** Tailwind-классы для бейджа статуса. */
export const STATUS_BADGE_CLASS: Record<ModuleProgressStatus, string> = {
  not_started: 'bg-slate-100 text-slate-600',
  in_progress: 'bg-brand-50 text-brand-700',
  done: 'bg-green-50 text-green-700',
  needs_rework: 'bg-orange-50 text-orange-700',
};

/** Левая полоска цвета у карточки модуля. */
export const STATUS_BAR_CLASS: Record<ModuleProgressStatus, string> = {
  not_started: 'bg-slate-300',
  in_progress: 'bg-brand-500',
  done: 'bg-green-500',
  needs_rework: 'bg-orange-500',
};
